import { motion } from 'framer-motion';
import styled, { css } from 'styled-components';

import { StyledSpinner } from '../DesignSystem/components/Loaders/styles';

export const ToastsWrapper = styled.div`
    position: fixed;
    left: 0;
    bottom: 0;
    z-index: 202;

    width: 100%;
    pointer-events: none;
    padding: 0 20px;
`;

export const ToastsPadding = styled.div`
    position: relative;

    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    width: 100%;
`;

export const ToastInside = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 10px;
    user-select: none;
`;

export const ToastBorder = styled(motion.div)<{ $minimal?: boolean }>`
    position: absolute;
    bottom: 50px;

    min-height: 56px;
    min-width: 360px;

    pointer-events: all;

    display: flex;
    overflow: hidden;
    cursor: pointer;

    padding: 2px;
    border-radius: 100px;

    background: linear-gradient(93.96deg, #6200de 5.04%, #ce88ff 51.19%, #bf28ff 96.3%);
    box-shadow:
        rgba(0, 0, 0, 0.3) 0 19px 38px,
        rgba(0, 0, 0, 0.22) 0 15px 12px;

    @media (max-width: 768px) {
        min-height: 48px;
        min-width: 100%;
        bottom: 40px;
    }

    ${({ $minimal }) =>
        $minimal &&
        css`
            background: linear-gradient(93.96deg, #3f3c42 5.04%, #7e6c8a 51.19%, #533b5d 96.3%);
        `}
`;

export const ToastContent = styled.div<{ $hasEmoji?: boolean }>`
    background: linear-gradient(274.85deg, #221f3e 36.63%, #342945 89.13%);
    border-radius: 100px;

    width: 100%;

    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;

    overflow: hidden;

    position: relative;
    z-index: 1;

    padding: 10px 24px;
    @media (max-width: 768px) {
        padding: 8px 20px;
    }
    ${({ $hasEmoji }) =>
        $hasEmoji &&
        css`
            padding-left: 16px;
        `}
`;

export const ToastText = styled.div`
    font-family: 'Alliance No.1';
    font-weight: 700;
    font-size: 14px;
    line-height: 16px;
    letter-spacing: -0.02em;
    color: #ffffff;
    position: relative;
    z-index: 0;
    max-width: 100%;

    @media (max-width: 768px) {
        font-size: 12px;
    }
`;

export const ToastIcon = styled.div`
    font-size: 32px;
    line-height: 32px;
    position: relative;
    z-index: 2;
    display: flex;
    align-items: center;

    @media (max-width: 768px) {
        font-size: 28px;
        line-height: 28px;
    }
`;

export const ToastSpinner = styled(StyledSpinner)`
    width: 24px;
    height: 24px;
`;
